import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  editButton: {
    position: 'fixed',
    bottom: 20,
    right: 20,
  },
});

export default useStyles;
